export default "__VITE_ASSET__B8u_obCT__"